import { render, staticRenderFns } from "./PracticeOpsPage.vue?vue&type=template&id=5bf71e7a&scoped=true"
import script from "./PracticeOpsPage.vue?vue&type=script&lang=js"
export * from "./PracticeOpsPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeOpsPage.vue?vue&type=style&index=0&id=5bf71e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf71e7a",
  null
  
)

export default component.exports